import React, { useContext, useEffect, useState } from 'react';

import { Link as RouterLink } from 'react-router-dom';

import {
    Button,
    Card,
    CardContent,
    CardHeader,
    Checkbox,
    Divider,
    Grid,
    IconButton,
    Link,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    Tooltip,
    Typography
} from '@mui/material';

import DeleteIcon from '@mui/icons-material/Delete';
import EventBusyIcon from "@mui/icons-material/EventBusy";

import { stringToLocaleDateString } from '../../../../helpers';
import { UtenteLink } from '../../../common';
import { NavContext, NavRoutes } from "../../../contexts";
import { TipiContattiContext } from '../TipiContattiContext';

const LinkRouter = props => <Link {...props} component={RouterLink} />;

export const TipiList = ({
    searchText,
    itemsPerPage,
    disabled,
    onLoadMore,
    onExport,
    onImport,
    onActionClick,
    ...props
}) => {

    const {
        getRouteTo
    } = useContext(NavContext);

    const {
        state,
    } = useContext(TipiContattiContext);

    const {
        tipi
    } = state;

    const [validFilter, setValidFilter] = useState(true);

    const [pageIndex, setPageIndex] = useState(0);
    const pageIndexChangeHandler = (e, index) => {
        setPageIndex(index);
    }

    const deleteClickHandler = async (data) => {
        if (onActionClick)
            onActionClick("Delete", data);
    }

    const addNewClickHandler = () => {
        if (onActionClick)
            onActionClick("Add");

    }

    useEffect(() => {
        if (tipi && onLoadMore) {
            onLoadMore(0, pageSize, searchText, validFilter);
        }
    }, [searchText]);

    useEffect(() => {
        if (tipi && onLoadMore) {
            onLoadMore(0, pageSize, searchText, validFilter);
        }
    }, [validFilter]);

    const [pageSize, setPageSize] = useState(itemsPerPage);
    const pageSizeChangeHandler = (e) => {
        setPageSize(e.target.value)
    }

    useEffect(() => {
        if (tipi && onLoadMore) {
            onLoadMore(pageIndex, pageSize, searchText, validFilter);
        }
    }, [pageIndex, pageSize]);

    return (
        <div>
            <Typography
                color="textSecondary"
                gutterBottom
                variant="body2"
                sx={{ marginTop: 3 }}>
                {tipi ? tipi.totalCount : 0}&nbsp;Record trovati
            </Typography>
            <Card>
                <CardHeader
                    titleTypographyProps={{ variant: "h6" }}
                    title={
                        <Grid container justifyContent="space-between">
                            <Grid item style={{ display: "flex", alignItems: "center" }}>
                                <Typography variant="h6">
                                    Tutti i Tipi Attributo
                                </Typography>
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        color: "white !important",
                                    }}
                                >
                                    <Grid container>
                                        <Grid item xs={12}>
                                            <Checkbox
                                                onChange={(e) => {
                                                    setValidFilter(!validFilter);
                                                }}
                                                checked={validFilter}
                                                sx={{ color: "white" }}
                                            />
                                            <Typography variant="caption">ATTIVI</Typography>
                                        </Grid>
                                    </Grid>
                                </div>
                            </Grid>
                            <Grid item>
                                <Button
                                    variant="contained"
                                    disableElevation
                                    color="info"
                                    onClick={addNewClickHandler}
                                >
                                    Aggiungi
                                </Button>
                            </Grid>
                        </Grid>
                    }
                    sx={{ backgroundColor: "secondary.main", color: "white" }}
                />
                <Divider />
                <CardContent sx={{ padding: 0 }}>
                    <Table>
                        <TableHead sx={{ backgroundColor: "aliceblue", }}>
                            <TableRow>
                                <TableCell style={{ width: "50%" }}>Nome</TableCell>
                                <TableCell style={{ width: "10%" }}>Ordine</TableCell>
                                <TableCell align="center" style={{ width: "10%" }}>
                                    Inserito da
                                </TableCell>
                                <TableCell align="center" style={{ width: "10%" }}>
                                    Modificato da
                                </TableCell>
                                <TableCell align="center" style={{ width: "10%" }}>
                                    Data inserimento
                                </TableCell>
                                <TableCell align="center" style={{ width: "10%" }}>
                                    Data Modifica
                                </TableCell>
                                <TableCell align="right"></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {tipi && tipi.result.length > 0
                                && tipi.result.map((tipoContatto, index) => {
                                    return (
                                        <TableRow hover key={index}>
                                            <TableCell>
                                                <div sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    // padding:'4px'
                                                }}>
                                                    <div>
                                                        <Link
                                                            color="textPrimary"
                                                            onClick={() => window.open(getRouteTo(NavRoutes.TipoContatto, [tipoContatto.id]), "_blank").focus()}
                                                            sx={{ fontWeight: 700, cursor: "pointer" }}>
                                                            {tipoContatto.nome}
                                                            {[
                                                                tipoContatto.fineValidita,
                                                            ].some((x) => x && x <= new Date()) && (
                                                                    <EventBusyIcon
                                                                        color={
                                                                            "error"
                                                                        }
                                                                    />
                                                                )}
                                                        </Link>
                                                    </div>
                                                </div>
                                            </TableCell>
                                            <TableCell>
                                                <Typography>
                                                    {tipoContatto.ordine}
                                                </Typography>
                                            </TableCell>
                                            <TableCell align="center">
                                                <UtenteLink utenteId={tipoContatto?.creatoDa} />
                                            </TableCell>
                                            <TableCell align="center">
                                                <UtenteLink utenteId={tipoContatto?.aggiornatoDa} />
                                            </TableCell>
                                            <TableCell align="center">
                                                {stringToLocaleDateString(tipoContatto.dataCreazione)}
                                            </TableCell>
                                            <TableCell align="center">
                                                {stringToLocaleDateString(tipoContatto.dataAggiornamento)}
                                            </TableCell>
                                            <TableCell align="right" sx={{
                                                'margin': '0px',
                                                'padding': '0px',
                                                'paddingRight': '8px',
                                            }}>
                                                <IconButton

                                                    sx={{
                                                        // 'margin':'0px'
                                                    }}
                                                    size='small'

                                                    aria-label="delete"
                                                    disabled={disabled}
                                                    onClick={() => deleteClickHandler(tipoContatto)}>
                                                    <Tooltip title="elimina tipo">
                                                        <DeleteIcon />
                                                    </Tooltip>
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })
                            }
                        </TableBody>
                    </Table>
                </CardContent>
                <TablePagination
                    component="div"
                    count={tipi ? tipi.totalCount : 0}
                    onPageChange={pageIndexChangeHandler}
                    onRowsPerPageChange={pageSizeChangeHandler}
                    page={pageIndex}
                    rowsPerPage={pageSize}
                    rowsPerPageOptions={[5, 10, 25]}
                />
            </Card>
        </div>
    );
}